<template>
  <div class="outlook">
    <div class="window">
      <div class="window-title">
        <div class="window-buttons">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="window-object">{{ $t("mail.title") }}</div>
      </div>
      <div class="window-toolbar" v-if="false">
        <img src="static/svg/delete.svg" width="30">
        <div class="window-toolbar-separator"></div>
        <img src="static/svg/reply.svg" width="30">
        <img src="static/svg/reply-all.svg" width="30">
        <img src="static/svg/forward.svg" width="30">
      </div>
      <div class="window-body">
        <div class="window-header">
          <div class="window-header_avatar">
            <img src="static/svg/avatar.svg" width="46">
          </div>
          <div>
            <span class="window-header_object">{{ $t("mail.object") }}</span><br>
            <span class="window-header_dest">{{ $t("mail.to") }}<span class="window-header_pastille"></span>{{ $t("mail.recipient") }}</span>
          </div>
        </div>
        <hr>
        <div class="window-preview">{{ typing }}</div>
        <div class="outlook-signature" id="outlook-signature">
          <table width="350" cellspacing="0" cellpadding="0" border="0" bgcolor="#ffffff" style="background:#ffffff;">
            <!--[if (mso)|(mso 16)]>
              <style type="text/css">
              a {text-decoration: none;}
              </style>
              <![endif]-->
            <tr>
              <td style="vertical-align: top; text-align:left;color:#231f20;font-size:13px;font-family:arial, helvetica;">
                <span style="color:#231f20;font-size:13px;font-family:arial, helvetica">{{name}} {{lastname}}</span>
                <br/>
                <span style="color:#666666;font-size:13px;font-family:arial, helvetica">{{job}}</span>
                <span v-if="pronouns" style="color:#666666;font-size:13px;font-family:arial, helvetica"><br/>{{ $t('mail.pronouns') }}: {{pronouns}}</span>
                <br/>
                <a title="PublicisSapient" target="_blank" :href="redirect_url" style="text-decoration: none;">
                  <img :width="pslogos[pslogo].width" :height="pslogos[pslogo].height" align="center" title="PublicisSapient" alt="PublicisSapient" :src="pslogos[pslogo].url"  style="padding-bottom: 0;display: inline !important;vertical-align: bottom;border: 0; outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;">
                </a>
                <br/>
                <span v-if="office" style="color:#666666;font-size:13px;font-family:arial, helvetica;text-decoration:none;" v-html="offices[office].address"></span>
                <br v-if="mobile || phone" />
                <br v-if="mobile || phone" />
                <span v-if="phone" style="color:#666666;text-decoration:none;">T &nbsp; {{formattedPhone}}<br v-if="mobile"/></span>
                <span v-if="mobile" style="color:#666666;text-decoration:none;">M &nbsp;{{formattedMobile}}</span>
              </td>
            </tr>
          </table>
          <br v-if="accolade.length" />
          <span v-for="acc in accolade" 
            :key="acc">
            <span v-if="accolades[acc] && accolades[acc].url">
              <strong v-if="!accolades[acc].href" :width="accolades[acc].width">
                <img v-if="!accolades[acc].href" :width="accolades[acc].width" :height="accolades[acc].height" align="center" alt="" :src="accolades[acc].url" style="padding-bottom: 0;display: inline !important;vertical-align: bottom;border: 0; outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;" />
              </strong>
              <a v-if="accolades[acc].href" :href="accolades[acc].href" target="_blank">
                <img :width="accolades[acc].width" :height="accolades[acc].height" align="center" alt="" :src="accolades[acc].url" style="padding-bottom: 0;display: inline !important;vertical-align: bottom;border: 0; outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;" />
              </a> &nbsp;&nbsp;&nbsp;&nbsp;
            </span>
           </span>
          <br v-if="accolade.length" />
          <br v-if="donate" />
          <br v-if="donate" />
          <table class="donate" cellpadding="0" cellspacing="0" v-if="donate" style="width: 100%; color:#666666;font-size:13px;font-family:arial, helvetica">
            <tr>
              <td class="donate-flag" width="24">
                <a href="https://helping-our-ukraine-team-as-one.iraiser.eu/b/my-donation?cid=1&_cv=1">
                  <img src="https://ps-email-signature-generator.s3.amazonaws.com/Aperture_Ukraine.png"  width="24" height="24">
                </a>
              </td>
              <td class="donate-object" style="padding-left:8px; color: rgb(102, 102, 102); font-size: 10px; font-family: arial, helvetica; line-height: 14px;" v-html="$t('mail.donate_ukraine')">
                
                
              </td>
            </tr>
          </table>
          <br/>
          <br/>
          <span v-if="office && offices[office].disclaimer" style="padding-top: 10px;color:#666666;text-decoration:none;font-size:9px;font-family:arial, helvetica;" v-html="offices[office].disclaimer"></span>
        </div>
      </div>
    </div>
    <div class="ga_generate"></div>
  </div>
</template>

<script>
import EventBus from '../eventBus';

import offices from '../labels/offices';
import accolades from '../labels/accolades';
import pslogos from '../labels/pslogolist';

import Utils from '../utils';

export default {
  name: 'ESOutlook',
  data: function () {
    return {
      name: '',
      lastname: '',
      job: '',
      pronouns: '',
      mobile: '',
      formattedMobile: '',
      phone: '',
      formattedPhone: '',
      office: '',
      offices: offices,
      accolade: [],
      accolades: accolades,
      pslogo:'PS_Brand',
      pslogos:pslogos,
      typing: '',
      lang: 'fr',
      courtesy: this.$i18n.t('mail.courtesy'),
      index: 0,
      preview: true,
      animated: true,
      colors: 0,
      signature_url: '',
      redirect_hash: '',
      uuid: '',
	  donate: this.donate,
      icons: {
        verticale: {name: 'all'},
        expertise: {name: 'business-analyst'},
        hobby: {name: 'alien'},
      },
    }
  },
  computed: {
    cleanJob: function () {
      return encodeURIComponent(this.job);
    },
    mobile_formated: function() {
      return Utils.formatPhone(this.mobile, '+33');
    },
    phone_formated: function() {
      return Utils.formatPhone(this.phone, '+33');
    },
    redirect_url: function() {
      // if (this.redirect_hash) {
        // return `${process.env.GENERATOR_URL}/redirect/${this.redirect_hash}`;
      // } else {
        return 'https://www.publicissapient.com';
      // }
    },
  },
  mounted: function() {
    EventBus.$on('changeInput', this.onChangeInput);
    EventBus.$on('changeOffice', this.onChangeOffice);
    EventBus.$on('changePSlogo', this.onchangePSlogo);
    EventBus.$on('changeAccolade', this.onChangeAccolade);
    EventBus.$on('changeAnimated', this.onChangeAnimated);
    EventBus.$on('changeColors', this.onChangeColors);
    EventBus.$on('changeIcon', this.onchangeIcon);
    EventBus.$on('changeLanguage', this.changeLanguage);
    EventBus.$on('formValidated', this.formValidated);
    this.uuid = Utils.getUuid();
    this.createInterval();
  },
  methods: {
    formValidated: function() {
      var panelLeft = document.querySelector('.panels__side--left');
      var panelRight = document.querySelector('.panels__side--right');
      panelRight.classList.toggle('panels__side--right-active');
      panelLeft.classList.toggle('panels__side--left-hidden');

      const buttonIntegrate = document.querySelector('.buttonIntegrate');
      buttonIntegrate.classList.toggle('active');

      this.preview = !buttonIntegrate.classList.contains('active');
      if (!this.preview) {
        const datasSignature = {
          hasMobile: this.mobile ? true : false,
          hasPhone: this.phone ? true: false,
          variables: `${this.lang}`,
        }

        // proceed without call to backend
        Utils.generateTag('gif-server', 'build', `${datasSignature.variables}!${this.office}!${datasSignature.hasMobile}!${datasSignature.hasPhone}!v2`)
        EventBus.$emit('genaration-ready', true);
        
        // postToGenerate call below is part of legacy code that made a call to a backend service
        /*
        Api.postToGenerate({
          verticale: this.icons.verticale.name,
          expertise: this.icons.expertise.name,
          hobby: this.icons.hobby.name,
          lang: this.lang,
          colors: this.colors,
          animated: this.animated,
          job: this.cleanJob,
          office: this.office,
          uuid: this.uuid,

          accolade: this.accolade.toString(),
        }).then(r => {
          console.log(r);
          if (r.url) {
            this.signature_url = r.url;
          }
          if (r.redirect_hash) {
            this.redirect_hash = r.redirect_hash;
          }
          if (r.success) { 
            Utils.generateTag('gif-server', 'build', `${datasSignature.variables}!${this.office}!${datasSignature.hasMobile}!${datasSignature.hasPhone}!v2`)
            EventBus.$emit('genaration-ready', true);
          } else {
            if (r.message) {
              EventBus.$emit('error-message', r.message);
            }
            EventBus.$emit('genaration-ready', false);
          }
        });
        */

      }
    
    },
    onChangeInput : function(value, name) {
      this[name] = value;
    },
    onChangeOffice: function(value) {
      this.office = value;
    },
    onchangePSlogo: function(value) {
      this.pslogo = value;
    },
    onChangeAccolade: function(value) {
      this.accolade = value;
    },
    onChangeAnimated: function(value) {
      this.animated = value;
    },
    onChangeColors : function(value) {
      this.colors = value;
    },
    onchangeIcon: function(obj) {
      this.icons[obj.id] = {
        name: obj.name.replace('_', '-'),
      }
    },
    changeLanguage: function(lang) {
      this.lang = lang;
      clearInterval(this.intervalid);
      this.courtesy = this.$i18n.t('mail.courtesy');
      this.createInterval();
    },
    createInterval: function() {
      this.intervalid = setInterval(function() {
        if (this.index > this.courtesy.length) {
          clearInterval(this.intervalid);
        }
        this.typing = this.courtesy.slice(0, this.index);
        this.index += 1;
      }.bind(this), 60);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Outlook.vue